import { Debouncer } from "./index"

export default {
    data() {
        return {
            debouncer: new Debouncer()
        }
    }
}
